<template>
  <layout-default>
    <the-toolbar
      @click-close="closeEditor"
      close
    />
    <form-constructor
      @save-form="onSaveNews"
      @toggle-publish="onTogglePublished"
      @modal-switch="onModalSwitch"
      @openTagsModal="showTags"
      @openKeywordsModal="showKeywords"
      @edit-block="onEditBlock"
      @story-modal="showStoryChangeModal"
      :save-btn-loader="saveBtnLoader"
      :policies="cutPolicies(policies, 'Articles')"
      content-blocks
      block-adder
      story-change
      deffered-date
      check-header
      :formDataId="activityId"
    />

    <TransitionGroup name="bounce">

      <BaseModalWindow
        v-show="modalState.Image"
        @close-modal="onModalSwitch"
        title="Добавление фотографий"
      >
        <ImageUploader
          ref="imageUploaderRef"
          for-content-blocks
          main-photo
          @close-modal="onModalSwitch"
        />
      </BaseModalWindow>

      <BaseModalWindow
        v-if="modalState.Story"
        @close-modal="onModalSwitch"
        title="История изменений"
      >
        <StoryChangeModal
          :selected-default-id="formData.Id"
          :data-table="changeHistoryData"
          @select-version="onSelectHystoryItem"
          @close-modal="onModalSwitch"
        />
      </BaseModalWindow>

      <BaseModalWindow
        v-if="modalState.Video"
        @close-modal="onModalSwitch"
        title="Добавление видео"
      >
        <VideoUploader
          @close-modal="onModalSwitch" @save-video="addVideoToContentBlock"
        />
      </BaseModalWindow>

      <BaseModalWindow
        v-if="tagsModalVisible"
        @close-modal="closeTagsModal"
        title="Теги навигации"
      >
        <TagsModalNew :categoryId="activityId"/>
      </BaseModalWindow>

      <BaseModalWindow
        v-if="keywordsModalVisible"
        @close-modal="closeKeywordsModal"
        title="Поисковые ключевые слова"
      >
        <KeywordsModal :categoryId="activityId"/>
      </BaseModalWindow>

    </TransitionGroup>

  </layout-default>
</template>

<script>
import { computed, ref, onBeforeMount } from 'vue'
import { useStore } from 'vuex'
import router from '@/router'
import { useRoute } from 'vue-router'

import LayoutDefault from '@/layout/LayoutDefault.vue'
import TheToolbar from '@/components/blocks/TheToolbar.vue'
import FormConstructor from '@/components/blocks/FormConstructor.vue'
import BaseModalWindow from '@/components/modals/BaseModalWindow.vue'
import ImageUploader from '@/components/modals/ImageUploader.vue'
import StoryChangeModal from '@/components/modals/StoryChangeModal.vue'
import VideoUploader from '@/components/modals/VideoUploader.vue'
import TagsModalNew from '@/components/modals/TagsModalNew.vue'
import KeywordsModal from '@/components/modals/KeywordsModal.vue'

import { cutPolicies } from '@/helpers/policiesValidator.js'

export default {
  name: 'NewsEditorEducationView',
  components: {
    LayoutDefault,
    TheToolbar,
    FormConstructor,
    BaseModalWindow,
    ImageUploader,
    StoryChangeModal,
    VideoUploader,
    TagsModalNew,
    KeywordsModal
  },
  setup () {
    const store = useStore()
    const route = useRoute()

    onBeforeMount(() => {
      // запрос на получение формы редактирования новости
      store.dispatch('setNewsFormEducation', route.params.id)
    })

    const policies = computed(() => store.getters.getPolicies)

    const closeEditor = () => {
      // редирект назад на таблицу с новостями
      router.push('/news-education')
    }

    const formData = computed(() => store.getters.getFormData)
    // объект формы товара (данные которые отобр. в конструкторе)

    const tagsModalVisible = computed(() => store.getters.getShowTagsEditor)

    const keywordsModalVisible = computed(() => store.getters.getShowKeywordsEditor)

    const imageUploaderRef = ref(null) // доступ к экземпляпляру редактора фото

    // ------ методы вызываемые из конструктора (начало) -----
    const saveBtnLoader = ref(false) // прелоадер на кнопке сохр
    const onSaveNews = async () => {
      // дожидается пока форма сохранится после чего запрашивает новую форму с новым Id версии и добавляет этот ID в параметр роутера
      saveBtnLoader.value = true // вкл лоадер кнопки

      // провереям создание это или редактирование новости и запускаем запрос на создание или на редактирование соответственно
      if (formData.value.Id === 0) {
        await store.dispatch('setSaveNewsEducation', formData.value)
        saveBtnLoader.value = false // выкл лоадер кнопки
        router.push(`/news-education/editor/${formData.value.Id}`)
      } else {
        await store.dispatch('setUpdateNewsEducation', formData.value)
        saveBtnLoader.value = false // выкл лоадер кнопки
      }
    }

    const onTogglePublished = (val) => {
      // опубликовать или снять с публикации
      formData.value.Published = val
      store.dispatch('setToggleNewsEducationPublish', val)
    }

    const onEditBlock = (e) => {
      // ВРЕМЕННОЕ РЕШЕНЕИЕ
      console.log('e.Type: ', e.Type)
      if (e.Type === 'Image') {
        // очищаем данные в компоненте
        imageUploaderRef.value.clearData()
        // добавляет в массив фоток фотографии из контент блока
        imageUploaderRef.value.fotosArr = e.Images
        // делает выбранным изображением первое из контент блока
        imageUploaderRef.value.onSelectImage(e.Images[0], 0)
        // включает спиннер на 2 секунды для плавного рендеринга
        imageUploaderRef.value.spinner = true

        setTimeout(() => {
          imageUploaderRef.value.spinner = false
        }, 2000)
        // открывает модалку
        modalState.value.Image = true
        store.commit('SetEditableImages', e.Images)
      }
    }
    // ------ методы вызываемые из конструктора (конец) -----

    // ------ модалки (начало)------
    const modalState = ref({
      Image: false, // загрузчик фото
      Video: false, // загрузчик видео
      Story: false, // история изменений
      Tags: false // ключ слова и теги
    })

    const onModalSwitch = (modal, val = false) => {
      console.log('val: ', val)
      console.log('modal: ', modal)
      // modal -- это строка с именем модалки
      // val -- булевое значение
      if (modal === 'all') {
        for (const key in modalState.value) {
          modalState.value[key] = val
        }
      }
      // если вызываем модалку с imageUploader то очищаем предварительно его данные
      if (modal === 'Image' && val) {
        imageUploaderRef.value.clearData()
      }

      modalState.value[modal] = val
    }

    const addVideoToContentBlock = (link) => {
      store.commit('SetAddVideoContentBlock', link)
      store.commit('SetAddContentBlock')
      onModalSwitch('Video', false)
    }

    const changeHistoryData = computed(() => {
      // данные из ьаблички в модалке с историей версий
      return store.getters.getChangeHistoryData
    })

    const showStoryChangeModal = () => {
      // загружаем данные и показываем модалку истории версий
      store.dispatch('setChangeHistory', `/Articles/GetChangeHistory/${formData.value.Id}`)

      onModalSwitch('Story', true)
    }

    const onSelectHystoryItem = (selectedId) => {
      // загружаем версию в первую колонку и открываем страницу истории изменений
      store.dispatch('setFirstColData', `/Articles/GetForm/${selectedId}`)
      router.push(`/news/version/${formData.value.Id}`)
    }
    // ------ модалки (конец)------

    const showTags = () => {
      store.dispatch('setTagsDataEducation')
      store.commit('SetShowTagsEditor', true)
    }

    const showKeywords = () => {
      store.dispatch('setKeywordsDataEducation')
      store.commit('SetShowKeywordsEditor', true)
    }

    const closeTagsModal = () => {
      store.commit('SetShowTagsEditor', false)
      store.dispatch('setClearCacheInnerTagEducation')
    }

    const closeKeywordsModal = () => {
      store.commit('SetShowKeywordsEditor', false)
      store.dispatch('setClearCacheInnerKeywordsEducation')
    }

    const activityId = 2

    return {
      closeEditor,
      formData,
      policies,
      onSaveNews,
      onTogglePublished,
      modalState,
      onModalSwitch,
      imageUploaderRef,
      onEditBlock,
      cutPolicies,
      addVideoToContentBlock,
      showStoryChangeModal,
      changeHistoryData,
      onSelectHystoryItem,
      saveBtnLoader,
      tagsModalVisible,
      keywordsModalVisible,
      showTags,
      showKeywords,
      closeTagsModal,
      closeKeywordsModal,
      activityId
    }
  }
}
</script>

<style lang="scss" scoped>
.bounce-enter-active {
  animation: bounce-in 0.5s;
}
.bounce-leave-active {
  animation: bounce-in 0.5s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.25);
  }
  100% {
    transform: scale(1);
  }
}

</style>
